<template>
    <div class="tabs-cmp">
        <div class="buttons-container">
            <button class="tab-btn" v-for="(tab, index) in tabs" :key="index" @click="(e)=>renderTabs(e,tab.base,tab.path)">{{ tab.name }}<v-icon class="icon"
                    icon>{{ tab.icon }}</v-icon></button>
        </div>
        <div class="current-tab">
            <RouterView />
        </div>
    </div>
</template>

<script>
export default {
    name: "Tabs",
    props: {
        tabs: {
            type: Array,
            require: true
        }
    },
    mounted(){
        document.querySelector(".tab-btn").click();
    },
    methods:{
        renderTabs(e,base,path){
            document.querySelectorAll(".tab-btn").forEach((el)=>{
                if(el != e.target){
                    el.classList.remove("active");
                }
            })
            if(!e.target.classList.contains("active")){
                e.target.classList.add("active")
                this.$router.push(`/${base}/${path}?${this.$route.fullPath.split("?")[1]}`);
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.tabs-cmp {
    display: flex;
    flex-direction: column;
    .buttons-container{
        width: fit-content;
        display: flex;
        flex-direction: row;
        margin-bottom: 30px;
        background-color: var(--v-alternativeBtnBackground-base);
        border-radius: 14px;
        button {
            display: flex;
            align-items: center;
            position: relative;
            padding: 8px 60px;
            background-color: transparent;
            color: var(--v-mainBlack-base) !important;
            font-family: 'Product Sans', sans-serif;
            border-radius: 14px !important;
            border: 0 !important;
            font-size: 14px;
            margin-left: -20px;
            &:first-of-type{
                margin-left: 0;
            }
            &:hover{
                color: var(--v-mainWhite-base) !important;
                background-color: var(--v-alternativeBtnBackground-base) !important;
            }
            .icon{
                margin-left: 5px;
                font-size: 14px;
                color: inherit !important;
            }
            &.active{
                color: var(--v-mainBlack-base) !important;
                background-color: var(--v-mainBtnBackground-base);
                z-index: 2;
                .icon{
                    color: var(--v-mainBlack-base) !important;
                }
            }
        }
    }
}
</style>